import { render } from "./CollectionDetailedSearchPrange.vue?vue&type=template&id=ba120e7c&scoped=true&ts=true"
import script from "./CollectionDetailedSearchPrange.vue?vue&type=script&lang=ts"
export * from "./CollectionDetailedSearchPrange.vue?vue&type=script&lang=ts"

import "./CollectionDetailedSearchPrange.vue?vue&type=style&index=0&id=ba120e7c&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src866133389/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba120e7c"]])

export default __exports__